module.exports = __webpack_public_path__ + "static/media/Egg.d8269a58.svg";